import { Component, Input, Optional, Self } from '@angular/core';
import { NgControl } from '@angular/forms';

@Component({
  selector: 'flow-form-textarea',
  templateUrl: './form-textarea.component.html',
  styleUrls: ['./form-textarea.component.scss']
})
export class FormTextareaComponent {
  @Input() label: string = '';
  @Input() labelClass?: string;
  @Input() placeholder: string = '';
  @Input() options: any[] = [];
  @Input() required: boolean = false;
  @Input() infoTooltip: string = '';
  @Input() errorMessage = '';
  @Input() errorMessageClass?: string;

  value: any;
  disabled = false;

  constructor(@Optional() @Self() protected control: NgControl) {
    if (this.control) {
      this.control.valueAccessor = this;
    }
  }

  onChange: (value: any) => void = () => { };
  onTouched: () => void = () => { };

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }


  onInput(event: Event): void {
    const val = (event.target as HTMLTextAreaElement).value;
    this.value = val;
    this.onChange(val);
  }

  onBlur(): void {
    this.onTouched(); 
  }
}